/**
 * Code by Mathieu VANBESELAERE for ->
 * @copyright Copyright (c) Agence ink
 */

// ** Module summary ** //
// Will simulate a click on the last image if a "see more" button is detected

export const gallery = () => {
    let seeMoreBtn = document.querySelector('[data-see-more]');
    if (seeMoreBtn) {
        let imgs = document.querySelectorAll('.gallery-wrapper img');
        seeMoreBtn.addEventListener('click', () => {
            imgs[5].click();
        });
    }
    return;
};
